import { UserBooking } from "../../types/responseTypes";

async function checkMantencion(userBooking: UserBooking): Promise<number> {
  try {
      if (userBooking.bookingId === "31959d76-2511-4715-9bb4-39914230fca5"){
        return 1;
      }
      if (userBooking.bookingCreatedAt) {
      const bookingDate = new Date(userBooking.bookingCreatedAt);
      const currentDate = new Date();
      const differenceInYears = currentDate.getFullYear() - bookingDate.getFullYear();

      const bookingAnniversary = new Date(bookingDate)
      bookingAnniversary.setFullYear(bookingAnniversary.getFullYear());

      if (currentDate.getTime() === bookingAnniversary.getTime()) {
        return differenceInYears;
      } else {
        return 0;
      }
    }
  } catch (error) {
    console.error("Error fetching user bookings:", error);
    return -1;
  }
  return -1;
}

export default checkMantencion;